"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./Table.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TableRow(_ref) {
  var Component = _ref.componentEl,
      children = _ref.children,
      className = _ref.className,
      padding = _ref.padding,
      margin = _ref.margin,
      isHeader = _ref.isHeader,
      hoverable = _ref.hoverable,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "children", "className", "padding", "margin", "isHeader", "hoverable"]);

  var cssClasses = ['st_table__row'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    padding: padding,
    margin: margin,
    cssClasses: cssClasses
  });
  if (hoverable) cssClasses.push('st_table__row--hoverable');
  var childrenWithProps = children; // if this is a header row, make all cells inside it header cells
  // and add scope="col"

  if (isHeader) {
    cssClasses.push('st_table__row--header');
    childrenWithProps = _react["default"].Children.map(children, function (child) {
      if (child.type.displayName !== 'Table.Cell') {
        return child;
      } // if it's an empty cell that has no element defined
      // make it a TD and don't add scope/th


      if (!child.props.componentEl && !child.props.children) {
        return _react["default"].cloneElement(child, {
          componentEl: 'td',
          isLabel: true
        });
      } // if cell has content, default to <th>, mark as header, and add scope if not set


      return _react["default"].cloneElement(child, {
        componentEl: child.props.componentEl || 'th',
        isLabel: true,
        scope: typeof child.props.scope !== 'undefined' && child.props.scope || 'col'
      });
    });
  }

  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' '),
    role: "row"
  }, otherProps), childrenWithProps);
}

TableRow.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** padding for cell, if any */
  padding: utils.spacing.paddingProps,

  /** margin for cell, if any */
  margin: utils.spacing.marginProps,

  /** whether it's a header row or regular row */
  isHeader: _propTypes["default"].bool,

  /** change background color on hover  */
  hoverable: _propTypes["default"].bool
};
TableRow.defaultProps = {
  componentEl: 'tr',
  className: null,
  margin: null,
  padding: null,
  isHeader: false,
  hoverable: false
};
TableRow.displayName = 'Table.Row';
var _default = TableRow;
exports["default"] = _default;